var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardOverviewSubscribedailyreport = function SvgNewcsDashboardOverviewSubscribedailyreport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_overview_subscribedailyreport_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25 514h32v32H25z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_overview_subscribedailyreport_svg__a)",
    transform: "translate(-25 -514)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#c5c8da",
    className: "newcs_dashboard_overview_subscribedailyreport_svg__border",
    transform: "translate(25.001 514)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    stroke: "none",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 3.5
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#807997",
    d: "m46.567 538.943-5.047-3.936a.1.1 0 0 0-.034-.025.72.72 0 0 0-.968 0 .2.2 0 0 1-.03.025l-5.013 3.926a1.44 1.44 0 0 1-1.555.324 1.46 1.46 0 0 1-.919-1.359V522.99a1.983 1.983 0 0 1 1.976-1.99h12.08a1.98 1.98 0 0 1 1.976 1.99v14.918a1.46 1.46 0 0 1-.913 1.358 1.5 1.5 0 0 1-.534.1 1.45 1.45 0 0 1-1.019-.423m-4.306-4.866 5.067 3.95a.5.5 0 0 1 .069.065.25.25 0 0 0 .291.065.25.25 0 0 0 .168-.248v-14.918a.8.8 0 0 0-.79-.8H34.981a.8.8 0 0 0-.79.8v14.908a.25.25 0 0 0 .168.248.25.25 0 0 0 .291-.064.4.4 0 0 1 .07-.065l5.028-3.936a1.94 1.94 0 0 1 1.263-.479 1.9 1.9 0 0 1 1.25.474m-1.787-3.239v-2.254h-2.312a.6.6 0 0 1-.592-.6.6.6 0 0 1 .592-.6h2.312v-2.444a.6.6 0 0 1 .592-.6.6.6 0 0 1 .593.6v2.444h2.351a.6.6 0 0 1 .592.6.6.6 0 0 1-.592.6h-2.351v2.254a.6.6 0 0 1-.593.6.6.6 0 0 1-.593-.601Z"
  }))));
};
export default SvgNewcsDashboardOverviewSubscribedailyreport;